// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2Qjd7","colLarge":"styles_colLarge__29WBN","col":"styles_col__1gYDG","colCheckbox":"styles_colCheckbox__3eDK3","actions":"styles_actions__2P8Kb"};